// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__2O0En","choiceBoxes":"toolbarselects_choiceBoxes__TmlmE","simpleField":"toolbarselects_simpleField__2hssp"};